import { render } from "./mianSecond.vue?vue&type=template&id=77e037e5&scoped=true"
import script from "./mianSecond.vue?vue&type=script&lang=js"
export * from "./mianSecond.vue?vue&type=script&lang=js"

import "./mianSecond.vue?vue&type=style&index=0&id=77e037e5&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-77e037e5"

export default script